/*
创建者 魏强(2018.2.1)
banner
*/
<template>
  <div class="banner-wrapper" :style="style">
    <div class="wrapper">
      <Carousel
        v-model="value"
        :autoplay="setting.autoplay"
        :autoplay-speed="setting.autoplaySpeed"
        :dots="setting.dots"
        :radius-dot="setting.radiusDot"
        :trigger="setting.trigger"
        :arrow="setting.arrow"
        :height="480"
        @on-change="change"
      >
        <CarouselItem v-for="item in data " :key="item.aid">
          <router-link class="img-box" :to="item.to" target="_blank">
          <img class="img-item" :src="item.atturl"  />
          </router-link>
        </CarouselItem>
      </Carousel>
    </div>
  </div>
</template>
<script>
  export default{
    props: ['data'],
    data () {
      let data = this.data
      let bgcolor = !!data ? data[0].bgcolor : "#fff";
      return {
        value: 0,
        setting: {
          autoplay: true,
          autoplaySpeed: 3000,
          dots: 'inside',
          radiusDot: true,
          trigger: 'hover',
          arrow: 'never',
          loop: true
        },
        style: {backgroundColor: bgcolor}
      }
    },
    methods: {
      change(oldValue, value){
        this.style = {backgroundColor: this.data[value].bgcolor}
      },
    }
  }
</script>
<style lang="less" scoped>
  .img-box, .img-item {
    height: 100%;
    width: 100%;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// banner.vue?f58ae30a